import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllTransactionNetworkDef = () => get(url.TRANSACTION_NETWORK_DEF_GET)